/* Construction views follow the approved Bouncy / Embrace heel presentation. */
(() => {
  'use strict';
  const pxConfig = () => {try{return JSON.parse(document.querySelector('[data-a6-product-config]').textContent)||{};}catch(_){return {};}};
  const pxAsset = name => pxConfig().assets?.[name]||'';
  const pxProduct = name => pxConfig().productUrls?.[name]||'/collections/all';

  const models = {
    plush: {
      name: 'Plush', id: 'p-support',
      eyebrow: 'SOFTNESS, WITH A FOUNDATION',
      heading: 'Soft where you meet it.<br>Firm where you need it.',
      intro: 'Plush puts a soft cushioning layer above a shaped base. Your arch has a surface to bear against. Your heel has a cup around it.',
      cushion: 'Soft, springy cushioning',
      feel: 'The yielding contact layer gives Plush its signature softness, with rebound as pressure lifts. It cushions your contact with the firmer support below.',
      viewBox: '580 515 600 345',
      points: [[865, 678], [865, 700], [865, 750]],
      marks: [[1133, 550], [1133, 652], [1133, 817]], elbow: 1030,
      close: '<div class="p-foundation-close"><p>The soft feeling you want.<br>The shaped support beneath it.</p><a class="p-link" href="#pdp-delivery">Will Plush feel right for me? <span aria-hidden="true">↗</span></a></div>'
    },
    fusion: {
      name: 'Fusion', id: 'f-foundation',
      eyebrow: 'CUSHION. CONTOUR. SUPPORT.',
      heading: 'The feeling above.<br>The foundation below.',
      intro: 'Your cushion and your support have different jobs. Fusion brings them together, from the contact beneath your foot to the shape beneath your arch.',
      cushion: 'Firmer-feel cushioning',
      feel: 'The two-color cushioning system gives beneath your weight with a more substantial feel than Embrace. You get cushioned contact without the same easy sink, and a calmer response than Plush.',
      viewBox: '580 515 600 345',
      points: [[865, 675], [865, 700], [865, 750]],
      marks: [[1133, 550], [1133, 652], [1133, 817]], elbow: 1030
    },
    honeycomb: {
      name: 'HoneyComb', id: 'hc-support',
      eyebrow: 'THE MATERIAL AND THE FOUNDATION',
      heading: 'Cushion the contact.<br><em>Support the foot.</em>',
      intro: 'A responsive cushioning layer above a contoured base. The material and the frame contribute different parts of the feeling beneath you.',
      cushion: 'Impact-responsive cushioning',
      feel: 'Flexible under gentler pressure, firmer when impact arrives quickly. The yellow cushioning adapts its response to the contact beneath your foot, above a separate supporting frame.',
      viewBox: '600 310 600 355',
      points: [[840, 525], [840, 543], [840, 580]],
      marks: [[635, 350], [635, 465], [635, 635]], elbow: 720
    }
  };

  function render({ model }) {
    const d = models[model];
    if (!d) return '';
    const imageId = `${d.id}-heel`;
    const paths = d.points.map(([x, y], i) => {
      const [mx, my] = d.marks[i];
      return `<path d="M${x} ${y} ${d.elbow} ${my}H${mx}"/>`;
    }).join('');
    const points = d.points.map(([x, y]) => `<circle cx="${x}" cy="${y}" r="4"/>`).join('');
    const numbers = d.marks.map(([x, y], i) => `<circle cx="${x}" cy="${y}" r="19"/><text x="${x}" y="${y}">${i + 1}</text>`).join('');
    const colorNote = model === 'fusion' ? 'Both the turquoise and blue layers belong to the cushioning system. The black strip below them is the EVA comfort layer.' : '';
    return `<section class="px-construction px-construction--${model}" id="${d.id}" aria-labelledby="${d.id}-title">
      <div class="pdp-shell">
        <header class="px-construction-heading">
          <p class="pdp-eyebrow">${d.eyebrow}</p>
          <h2 id="${d.id}-title">${d.heading}</h2>
          <p>${d.intro}</p>
        </header>
        <div class="px-construction-layout">
          <figure class="px-construction-photo">
            <svg viewBox="${d.viewBox}" role="img" aria-labelledby="${imageId}-title ${imageId}-desc">
              <title id="${imageId}-title">${d.name}’s three layers at the heel</title>
              <desc id="${imageId}-desc">Catalog heel view. One points to the cushioning, two to the intermediate EVA comfort layer, and three to the stability frame. ${colorNote} The heel is thicker than the one-millimeter forefoot EVA specification.</desc>
              <image href="${pxAsset(model+"-heel.webp")}" width="1200" height="1200"/>
              <g class="px-construction-leaders">${paths}</g>
              <g class="px-construction-points">${points}</g>
              <g class="px-construction-marks" text-anchor="middle" dominant-baseline="central">${numbers}</g>
            </svg>
            <figcaption>Cushioning above. Shaped support below.</figcaption>
          </figure>
          <ol class="px-construction-layers">
            <li><span class="px-construction-index" aria-hidden="true">1</span><div>
              <h3>${d.cushion}</h3>
              <p class="px-construction-spec">Approx. 0.16 in (4 mm)</p>
              <p>${d.feel}</p>
            </div></li>
            <li><span class="px-construction-index" aria-hidden="true">2</span><div>
              <h3>Contoured comfort layer</h3>
              <p class="px-construction-spec">Slim at the forefoot. Fuller at the heel.</p>
              <p>A shaped intermediate layer that follows the insole’s profile, between the cushioning and the supporting frame.</p>
              <details><summary>Thickness details <span aria-hidden="true">+</span></summary><p>EVA is approximately 0.04 in (1 mm) at the forefoot, with a thicker heel section. These layer measurements are not the full insole height.</p></details>
            </div></li>
            <li><span class="px-construction-index" aria-hidden="true">3</span><div>
              <h3>Stability frame</h3>
              <p class="px-construction-spec">Raised arch support · Deep heel cup</p>
              <p>A firm foundation beneath the comfort layers supports your arch and cradles your heel. The cushioning above softens your contact with that support.</p>
              <details><summary>Frame material <span aria-hidden="true">+</span></summary><p>Molded TPU forms the support frame. The frame connects through the center beneath the comfort layers.</p></details>
            </div></li>
          </ol>
        </div>
        ${d.close || ''}
      </div>
    </section>`;
  }
  window.PXConstruction = { render };
})();
